import React, {memo} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {Card, CardContent, Grid, Typography, Avatar} from '@material-ui/core';
import BarChartIcon from '@material-ui/icons/BarChart';
import {StatusArrow} from 'components';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
    },
    cardContent: {
        position: 'relative',
        top: '50%',
        transform: 'translateY(-50%)'
    },
    title: {
        fontWeight: 700,
        marginBottom: theme.spacing(3),
    },
    avatar: {
        backgroundColor: theme.palette.success.main,
        height: 56,
        width: 56,
    },
    icon: {
        height: 32,
        width: 32,
    },
    statusContainer: {
        marginTop: theme.spacing(2),
        display: 'flex',
        alignItems: 'center',
    },
    status: {
        marginRight: theme.spacing(1),
    },
    up: {
        color: theme.palette.error.main,
    },
    down: {
        color: theme.palette.info.main,
    },
    middle: {
        color: theme.palette.black,
    },
    caption: {
        marginRight: theme.spacing(1),
    },
}));

const TotalPoint = memo(props => {
    const {className, term, data, ...rest} = props;
    const classes = useStyles(props);
    // const termLabel = {
    //     'daily': 'date',
    //     'weekly': 'week',
    //     'monthly': 'month',
    // };

    if (!data) return null;

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent className={classes.cardContent}>
                <Grid
                    container
                    justify="space-between"
                >
                    <Grid item>
                        <Typography
                            className={classes.title}
                            color="textSecondary"
                            gutterBottom
                            variant="h3"
                        >
                            Total Num. of Deals
                        </Typography>
                        <Typography variant="h4">
                            reference {data.standardDate.toLocaleString()} Count
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Avatar className={classes.avatar}>
                            <BarChartIcon className={classes.icon}/>
                        </Avatar>
                    </Grid>
                </Grid>
                <div className={classes.statusContainer}>
                    <Typography
                        className={classes.caption}
                        variant="h4"
                    >
                        comparison {data.comparisonDate.toLocaleString()} Count
                    </Typography>
                    <StatusArrow
                        className={classes.status}
                        size="md"
                        type={data.status}
                    />
                    <Typography
                        className={classes[data.status]}
                        variant="h4"
                    >
                        {data.rate}%
                    </Typography>
                </div>
            </CardContent>
        </Card>
    );
});

TotalPoint.propTypes = {
    className: PropTypes.string,
    term: PropTypes.string,
    data: PropTypes.any,
};

export default TotalPoint;
